import { Link } from "gatsby";
import React from "react";
import "./paginator.scss";

export interface IPaginator {
  quantity: number;
  currentPage: number;
  slug: string;
}

const Paginator = (props: IPaginator) => {
  const { quantity, currentPage, slug } = props;
  const compClass = "m-paginator";
  const itemClass = (active) => {
    return `${compClass}__item ${
      active ? `${compClass}__item--active` : ""
    }`.trim();
  };
  let next = currentPage + 1;
  let back = currentPage - 1;
  return (
    <div className={compClass}>
      <Link
        to={`${currentPage === 2 ? slug : slug + back}`}
        className={currentPage < 2 ? "inactive" : "active"}
      >
        Atrás
      </Link>
      <div className={`${compClass}__desktop`}>
        {Array.from({ length: quantity }).map((_, index) => {
          if (index < currentPage - 3 && index !== 0) return ".";
          if (index > currentPage + 2 && index !== quantity - 1) return ".";
          return (
            <span
              className={itemClass(index + 1 === currentPage ? true : false)}
              key={index}
            >
              {index === 0 ? (
                <Link to={slug}>{index + 1}</Link>
              ) : (
                <Link to={slug + (index + 1)}>{index + 1}</Link>
              )}
            </span>
          );
        })}
      </div>
      <div className={`${compClass}__mobile`}>
        <span>{currentPage}</span>
        <span>de</span>
        <span>{quantity}</span>
      </div>
      <Link
        to={`${slug + next}`}
        className={currentPage < quantity ? "active" : "inactive"}
      >
        Siguiente
      </Link>
    </div>
  );
};

export default Paginator;
